/**
 * What's left of the academy PEOPLE mutations (F3-D) after plan 06 · E4:
 * **nothing that writes**.
 *
 * `createStudentProfileMutation`, `updateStudentProfileMutation`,
 * `updateStudentNotesMutation`, `createTeacherProfileMutation` and
 * `updateTeacherProfileMutation` used to live here: inserts and updates on
 * the local SQLite that the sync queue uploaded to the write-path. With
 * THIRD-PARTY rows out of the streams (`org_admin_scope`,
 * `campus_admin_scope`, `academy_org`) the `UPDATE … WHERE id = ?` found no
 * row and the staff edit got lost **silently**: no error, no op, no trace. Worse than a failure.
 *
 * Writing now lives on the server, which is where the permission already lived:
 *   · `PUT /api/academy/:orgId/students/:userId`
 *   · `PUT /api/academy/:orgId/teachers/:userId`
 *   · `POST|DELETE /api/org/{add,remove}Guardian` (already worked this way)
 *
 * The REST patch is SPARSE just like Drizzle's `set()` was: what isn't sent
 * doesn't get touched. That equivalence is what lets the screens keep their
 * shape when the transport changes.
 *
 * `slugifyPublicSlug` survives, since it writes nothing: it's a pure text
 * transformation the interface applies BEFORE sending the patch.
 */

/** Basic slugify for `public_slug` (lowercase, dashes, no accents). */
export function slugifyPublicSlug(input: string): string {
  return input
    .normalize("NFD")
    .replaceAll(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, "-")
    .replaceAll(/(^-+)|(-+$)/g, "")
    .slice(0, 64);
}
